<span class="reportable-receipts-title label-medium-emphasized">
  {{ 'receipts.ui.elencoIncassiDaRendicontare' | transloco }}
</span>

<div class="reportable-receipts-desktop">
  <span class="title-medium-emphasized">{{ 'receipts.ui.elencoIncassiDaRendicontare' | transloco }}</span>

  <div class="reportable-receipts-table-container">
    <table
      mat-table
      [dataSource]="incassiDaRendicontare"
      class="reportable-receipts-table"
    >
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.idIncasso' | transloco }}</th>
        <td mat-cell *matCellDef="let incasso">{{ incasso.id }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="zona">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.zona' | transloco }}</th>
        <td mat-cell *matCellDef="let incasso">{{ incasso.zona }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="cliente">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.cliente' | transloco }}</th>
        <td mat-cell *matCellDef="let incasso">{{ incasso.cliente }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="dataIncasso">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.dataIncasso' | transloco }}</th>
        <td mat-cell *matCellDef="let incasso">
          {{ incasso.dataIncasso | date:'dd/MM/yyyy' }}
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span class="body-medium-emphasized">{{ 'receipts.ui.totali' | transloco }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="importoContanti">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.contanti' | transloco }}</th>
        <td mat-cell *matCellDef="let incasso" class="currency-cell">
          {{ incasso.importoContanti | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleContantiSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="importoAssegni">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.assegni' | transloco }}</th>
        <td mat-cell *matCellDef="let incasso" class="currency-cell">
          {{ incasso.importoAssegni | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleAssegniSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="importoTotale">
        <th mat-header-cell *matHeaderCellDef>{{ 'receipts.ui.totale2' | transloco }}</th>
        <td mat-cell *matCellDef="let incasso" class="currency-cell">
          {{ incasso.importoTotale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleIncassiSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="selezionato">
        <th mat-header-cell *matHeaderCellDef class="checkbox-cell">
          <mat-checkbox
            [checked]="tuttiInclusi"
            [indeterminate]="selezioneParziale"
            [attr.aria-label]="'receipts.ui.includiTuttiGliIncassi' | transloco"
            (change)="impostaTuttiInclusi($event.checked)"
          />
        </th>
        <td mat-cell *matCellDef="let incasso" class="checkbox-cell">
          <mat-checkbox
            [checked]="incasso.selezionato"
            [attr.aria-label]="(('receipts.ui.includiIncasso' | transloco) + ' ') + incasso.id"
            (change)="impostaIncassoIncluso(incasso.id, $event.checked)"
          />
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colonneTabella"></tr>
      <tr mat-row *matRowDef="let row; columns: colonneTabella"></tr>
      <tr mat-footer-row *matFooterRowDef="colonneTabella"></tr>
    </table>
  </div>

  <div class="desktop-draft-actions">
    <button
      matButton="filled"
      type="button"
      class="desktop-action-button desktop-action-button--wide"
      *uiCan="CAPS.brogliaccioCrea"
      [disabled]="!almenoUnIncassoIncluso || isSaving"
      (click)="creaBrogliaccio()"
    >
      {{ 'receipts.ui.creaBrogliaccio' | transloco }}
    </button>

    <button
      matButton="outlined"
      type="button"
      class="desktop-action-button desktop-action-button--totals"
      [disabled]="!almenoUnIncassoIncluso"
      (click)="mostraTotaliPerZona()"
    >
      {{ 'receipts.ui.mostraTotaliPerZona' | transloco }}
    </button>

    <button
      matButton="outlined"
      type="button"
      class="desktop-action-button desktop-action-button--exit"
      (click)="tornaIndietro()"
    >
      {{ 'receipts.ui.esci' | transloco }}
    </button>
  </div>
</div>

<div class="reportable-receipts-content">
  <div class="include-all-row">
    <div class="include-all-checkbox-container">
      <mat-checkbox
        class="include-all-checkbox"
        [checked]="tuttiInclusi"
        [indeterminate]="selezioneParziale"
        (change)="impostaTuttiInclusi($event.checked)"
      >
        {{ 'receipts.ui.includiTutti' | transloco }}
      </mat-checkbox>
    </div>
  </div>

  <div class="reportable-receipts-list">
    @for (incasso of incassiDaRendicontare; track incasso.id) {
      <div class="reportable-receipt-card">
        <div class="reportable-receipt-data">
          <div class="receipt-checkbox-container">
            <mat-checkbox
              [checked]="incasso.selezionato"
              [attr.aria-label]="(('receipts.ui.includiIncasso' | transloco) + ' ') + incasso.id"
              (change)="impostaIncassoIncluso(incasso.id, $event.checked)"
            />
          </div>
          <div class="reportable-receipt-info">
            <div class="receipt-info-first-row">
              <div class="receipt-info-pair">
                <span class="body-small">{{ 'receipts.ui.id' | transloco }}</span>
                <span class="body-medium-emphasized">{{ incasso.id }}</span>
              </div>

              <div class="receipt-info-pair">
                <span class="body-small">{{ 'receipts.ui.zona2' | transloco }}</span>
                <span class="body-medium-emphasized">{{ incasso.zona }}</span>
              </div>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">{{ 'receipts.ui.cliente2' | transloco }}</span>
              <span class="body-medium-emphasized">{{ incasso.cliente }}</span>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">{{ 'receipts.ui.dataIncasso2' | transloco }}</span>
              <span class="body-medium-emphasized">
                {{ incasso.dataIncasso | date:'dd/MM/yyyy' }}
              </span>
            </div>

            <div class="receipt-info-row">
              @if (incasso.importoAssegni > 0) {
                <span class="body-small">{{ 'receipts.ui.assegni2' | transloco }}</span>
                <span class="body-medium-emphasized">
                  {{ incasso.importoAssegni | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                </span>
              } @else {
                <span class="body-small">{{ 'receipts.ui.contanti2' | transloco }}</span>
                <span class="body-medium-emphasized">
                  {{ incasso.importoContanti | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                </span>
              }
            </div>

            <div class="receipt-info-row">
              <span class="body-small">{{ 'receipts.ui.totale3' | transloco }}</span>
              <span class="body-medium-emphasized">
                {{ incasso.importoTotale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<div class="selected-receipts-summary">
  <div class="selected-receipts-summary-top">
    <div class="selected-receipts-summary-row">
      <span class="body-small">{{ 'receipts.ui.totaleContanti3' | transloco }}</span>
      <span class="body-small-emphasized">
        {{ totaleContantiSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
      </span>
    </div>

    <div class="selected-receipts-summary-row">
      <span class="body-small">{{ 'receipts.ui.totaleAssegni3' | transloco }}</span>
      <span class="body-small-emphasized">
        {{ totaleAssegniSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
      </span>
    </div>
  </div>

  <div class="selected-receipts-summary-divider"></div>

  <div class="selected-receipts-summary-bottom">
    <div class="selected-receipts-summary-row">
      <span class="body-large">{{ 'receipts.ui.totaleComplessivo2' | transloco }}</span>
      <span class="body-small-emphasized">
        {{ totaleIncassiSelezionati | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
      </span>
    </div>
  </div>
</div>

<div class="new-draft-actions">
  <button
    matButton="filled"
    type="button"
    *uiCan="CAPS.brogliaccioCrea"
    [disabled]="!almenoUnIncassoIncluso || isSaving"
    (click)="creaBrogliaccio()"
  >
    {{ 'receipts.ui.creaBrogliaccio' | transloco }}
  </button>

  <button
    matButton="outlined"
    type="button"
    [disabled]="!almenoUnIncassoIncluso"
    (click)="mostraTotaliPerZona()"
  >
    {{ 'receipts.ui.mostraTotaliPerZona' | transloco }}
  </button>
</div>
